import { Section, SectionTitle, PageHero, CTA } from "@/components/site/SiteBits";
import { Target, Compass, Award, Users } from "lucide-react";

export default function About() {
  return (
    <div>
      <PageHero eyebrow="About Ebik Logistics" title="A technology company that happens to move cargo"
        subtitle="Headquartered in Cape Town with a national distribution hub in Johannesburg, Ebik Logistics delivers enterprise-grade freight, warehousing and supply-chain solutions across Southern Africa."
        image="/services/freight-forwarding.jpg" />
      <Section>
        <div className="grid lg:grid-cols-2 gap-12">
          <div>
            <SectionTitle eyebrow="Our Story" title="Moving Southern Africa forward" />
            <div className="space-y-4 text-muted-foreground leading-relaxed">
              <p>Ebik Logistics was founded to close the gap between cargo demand and verified transport capacity across Africa. We combine a modern freight operation with a digital platform that delivers real-time visibility, automation and transparency.</p>
              <p>From port-to-warehouse container moves to cross-border corridors, we operate as an integration-first platform — designed to connect with your ERP, telematics, payments and customs systems as we scale across the continent.</p>
            </div>
          </div>
          <div className="grid sm:grid-cols-2 gap-4">
            {[
              { icon: Target, t: "Mission", d: "Connect cargo owners with reliable, verified transport capacity through technology." },
              { icon: Compass, t: "Vision", d: "A technology-driven logistics network spanning the whole of Africa." },
              { icon: Award, t: "Values", d: "Reliability, transparency, security, speed and sustainability." },
              { icon: Users, t: "People", d: "Local expertise across Cape Town, Johannesburg and Durban." },
            ].map((v) => (
              <div key={v.t} className="rounded-xl border border-border bg-card p-6">
                <v.icon className="text-primary" size={26} />
                <h3 className="mt-3 font-heading font-bold">{v.t}</h3>
                <p className="mt-2 text-sm text-muted-foreground">{v.d}</p>
              </div>
            ))}
          </div>
        </div>
      </Section>
      <CTA />
    </div>
  );
}
